var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _VideoWrapper_instances, _VideoWrapper_attachSortedVideoFiles;
import { roundRobinCDN } from '@core/helpers/video/roundRobinCDN';
import { isLiveStreamLive, isLiveStreamReplay } from '@core/livestream/helpers';
import { EnumVideoWrapperType } from '../types';
import { orderVideoFiles } from '../utils/video';
import { VideoElementWrapper } from './bases/VideoElementWrapper';
/**
 *
 */
export class VideoWrapper extends VideoElementWrapper {
    /**
     *
     */
    constructor(video, videoEl, preferredCDNs) {
        super(EnumVideoWrapperType.VIDEO, video, videoEl, preferredCDNs);
        _VideoWrapper_instances.add(this);
        __classPrivateFieldGet(this, _VideoWrapper_instances, "m", _VideoWrapper_attachSortedVideoFiles).call(this);
    }
    /**
     *
     */
    composeKey(video) {
        return `video-${video.encoded_id}-${video.file_url}`;
    }
    /**
     *
     */
    shouldReuse(video) {
        return this.composeKey(video) === this.key;
    }
    /**
     *
     */
    reset() {
        while (this.videoEl.firstChild) {
            this.videoEl.firstChild.remove();
        }
    }
    /**
     *
     */
    get elapsedTime() {
        return this.videoEl.currentTime;
    }
}
_VideoWrapper_instances = new WeakSet(), _VideoWrapper_attachSortedVideoFiles = function _VideoWrapper_attachSortedVideoFiles() {
    if (isLiveStreamReplay(this.video) && this.video.live_stream_replay_url) {
        // Livestream replay's requested to play thru VideoWrapper
        // will be played as a regular video (Safari handles HLS natively)
        this.videoEl.src = roundRobinCDN(this.video.live_stream_replay_url, this.preferredCDNs);
    }
    else if (
    // In case VideoWrapper has to handle livestream, it
    // will be played as a regular video (Safari handles HLS natively)
    isLiveStreamLive(this.video) &&
        this.video.live_stream_playback_url) {
        this.videoEl.src = roundRobinCDN(this.video.live_stream_playback_url, this.preferredCDNs);
    }
    else {
        orderVideoFiles(this.video, this.preferredCDNs)
            .map(({ src, type, codecs }) => {
            const el = document.createElement('source');
            el.src = src;
            el.type = codecs ? `${type}; codecs="${codecs}"` : type;
            return el;
        })
            .forEach((source) => this.videoEl.appendChild(source));
    }
    // Always trigger load when sources gets changed
    this.videoEl.currentTime = 0;
    this.videoEl.load();
};
